import MinorAthleteTraining from "../components/AthleteSafetyRVP/MinorAthleteTraining/MinorAthleteTraining";
import AdminView from "../components/shared/AdminView";
import ResourceLinkNav from "../components/shared/ResourceLinkNav/ResourceLinkNav";

const MinorAthleteTrainingPage = () => {
    return (
        <ResourceLinkNav>
            <AdminView />
            <MinorAthleteTraining />
        </ResourceLinkNav>
    );
}

export default MinorAthleteTrainingPage;